/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeS1Icon16Solid = forwardRef('MediaAudioVolumeS1Icon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.51 1.694 3.704 5H1.5A1.5 1.5 0 0 0 0 6.5v3A1.5 1.5 0 0 0 1.5 11h2.204l3.806 3.306a.9.9 0 0 0 1.49-.68V2.374a.9.9 0 0 0-1.49-.68Z" }),
        React.createElement("path", { d: "M11.594 4.906a.875.875 0 1 0-1.238 1.238 2.626 2.626 0 0 1 0 3.712.875.875 0 1 0 1.238 1.238 4.377 4.377 0 0 0 0-6.188Z" })));
});
